import React from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';

export function ExpandableTableHead(props) {
  const {
    align,
    colSpan,
    name,
    onRequestSort,
    order,
    orderBy,
    size,
    sortable,
    title,
    type,
  } = props;

  const createSortHandler = name => event => {
    onRequestSort(event, name);
  };

  function renderLabel() {
    if (sortable) {
      return <TableSortLabel
        active={orderBy === name}
        direction={order}
        onClick={createSortHandler(name)}
      >
        {title ?? name}
      </TableSortLabel>;
    }

    return title ?? name;
  }

  return (
    <TableCell
      align={align ? align : type === 'numeric' ? 'right' : 'left'}
      colSpan={colSpan}
      key={name}
      size={size}
      sortDirection={sortable && orderBy === name ? order : false}
      variant="head"
    >
      {renderLabel()}
    </TableCell>
  );
}
